import PropTypes from 'prop-types';

import { ReactSelectAsyncWithAxios } from '@hivebrite/design-system/Inputs';

const noOptionsMessage = ({ inputValue }) =>
  inputValue
    ? __('Job function %{jobFunction} not found').i__({
        jobFunction: inputValue,
      })
    : __('Search for a job function');

const ReactSelectJobFunctions = ({
  placeholder,
  isMulti,
  multiple,
  ...otherProps
}) => (
  <ReactSelectAsyncWithAxios
    {...otherProps}
    multiple={multiple || isMulti}
    loadOptionsUrl={Routes.search_job_functions_path({ format: 'json' })}
    placeholder={placeholder || __('Job function')}
    noOptionsMessage={noOptionsMessage}
  />
);

ReactSelectJobFunctions.propTypes = {
  placeholder: PropTypes.string,
};

export default ReactSelectJobFunctions;
